import React from 'lib/react';
import PropTypes from 'prop-types';
import {
  EVGrid,
} from 'lib/components';
import { useTranslation } from 'lib/translation';
import { IMAGE_FILES_PATH } from 'constants/AppConstants';
import { getKeyByValue } from 'utils/app.utils';
import {
  PAYMENT_CARD_TYPE_IDS,
} from 'commonComponents/paymentInformation/PaymentInformationConstants';
import PaymentInformationStyles from './PaymentSectionStyles';

function PaymentSectionHeader(props) {
  const {
    creditCardVisibility, creditCard,
  } = props;
  const { t } = useTranslation();
  const classes = PaymentInformationStyles();
  return (
    <EVGrid className={classes.panelHeader}>
      {t('finalize_order__payment_information')}
      {creditCardVisibility && (
      <>
        {creditCard && (
        <EVGrid className={classes.secondaryHeader}>
          {`${creditCard.creditCardNumber.slice(8, 12).replace(/\*|\d/g, 'X') + creditCard.creditCardNumber.slice(12)}`}
        </EVGrid>
        )}
        {creditCard && creditCard.creditCardType !== 0 && (
        <img
          src={`${IMAGE_FILES_PATH}/${getKeyByValue(PAYMENT_CARD_TYPE_IDS, creditCard.creditCardType)}.png`}
          alt="cardImage"
          className={classes.cardImage}
        />
        )}
      </>
      )}
    </EVGrid>
  );
}
PaymentSectionHeader.propTypes = {
  creditCardVisibility: PropTypes.bool.isRequired,
  creditCard: PropTypes.shape(),
};
PaymentSectionHeader.defaultProps = { creditCard: null };

export default PaymentSectionHeader;
